import React from "react";
// import { MdKeyboardDoubleArrowRight } from 'react-icons/md';
// import heroImage from '../assets/heroImage.png'; // Replace with the correct path to your image file

const Vision = () => {
  return (
    // <div
    //   name="about"
    //   className="w-full bg-gradient-to-b from-cyan-900 to-black  text-white md:h-screen"
    // >
    //   <div className=" max-w-screen-lg flex flex-col justify-center mx-auto pt-20 px-4 w-full h-full">
    //     <div className="pb-8">
    //       <p className=" text-4xl font-bold inline border-b-4 border-gray-500">
    //         My Vision
    //       </p>
    //     </div>
    //     <p className=" text-xl mt-18 text-left">
    //       I want to create technology that brings people closer, builds trust,
    //       and makes life easier. My goal is to design solutions that solve real
    //       problems, are simple to use, and have a positive impact. In an
    //       increasingly complex world, I strive to help systems function, adapt,
    //       and evolve through creativity and thoughtful design. Each project I
    //       work on aims to inspire, connect, and make technology more human and
    //       meaningful for everyone.
    //     </p>
    //   </div>
    // </div>
    <div
  name="vision"
  className="w-full bg-gradient-to-b from-cyan-900 to-black text-white md:h-auto"
>
  <div className="max-w-screen-lg flex flex-col justify-center mx-auto pt-20 px-4 w-full h-full">
    <div className="pb-4">
      <p className="text-4xl font-bold inline border-b-4 border-gray-500">
        My Vision
      </p>
    </div>
    <p className="text-xl mt-4 mb-16 text-left">
      I want to create technology that brings people closer, builds trust,
      and makes life easier. My goal is to design solutions that solve real
      problems, are simple to use, and have a positive impact. In an
      increasingly complex world, I strive to help systems function, adapt,
      and evolve through creativity and thoughtful design. Each project I
      work on aims to inspire, connect, and make technology more human and
      meaningful for everyone.
    </p>
  </div><br /><br />
</div>
  );
};

export default Vision;
